/**
 * Company: SPHMedia
 * Description: [Gets Long Form videos data]
 */

import fetchBHApi from "@helper/fetchBHApi";
import { ENABLE_MEDIA_CONTENT_INFINITE_SCROLL } from "@helper/getEnvVariables";
import { useEffect, useState } from "react";

import { LatestVideoResponse } from "../transformer/useBrightcoveResponse";

type useLongFormVideoData = {
  playing: LatestVideoResponse | undefined;
};

/**
 * Custom React Hook: useLongFormVideo
 * Description: [Gets Long Form videos from bc playlist]
 * @returns data - The data returned by the hook
 */
export default function useLongFormVideo(): useLongFormVideoData {
  const [playing, setPlaying] = useState<LatestVideoResponse>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const videos: LatestVideoResponse[] = await fetchBHApi<
          LatestVideoResponse[]
        >("latest-videos-playlist", "GET");
        const limitedContent = videos[0];
        setPlaying(limitedContent);
      } catch (error) {
        console.error(
          "[InfiniteScroll] Error fetching long-form video:",
          error,
        );
      }
    };
    if (ENABLE_MEDIA_CONTENT_INFINITE_SCROLL) {
      void fetchData();
    }
  }, []);

  return { playing };
}
